<template>
  <!-- <div :class="[type]" class="notice" :style="`top: calc(${posY}px + 1%)`"> -->
  <div :class="[type]" class="notice">
    <p v-if="title" class="title">{{title}}</p>
    <p v-if="text" class="text">{{text}}</p>
  </div>
</template>

<script>

export default {
  name: 'Notice',

  props: [
    'title',
    'text',
    'type',
  ],

  data() {
    return {
      posY: 0,
    }
  },

  mounted() {
    // this.posY = window.scrollY
    // setTimeout(this.noticeFalse, 5000)
  },

  methods: {
    noticeFalse() {
      this.$parent.isNotice = false
    }
  },
}

</script>

<style scoped>
.notice {
  position: fixed;
  top: 5%;
  right: 5%;
  right: 10px;
  width: 200px;
  min-height: 50px;
  padding: 10px;
  border-radius: 10px;
  color: #5C5C5C;
  animation-name: notice;
  animation-duration: 5s;
  animation-iteration-count: 1;
  z-index: 100;
  box-shadow: 0, 0.1, 0.1, rgba(0,0,0,0.4);
}

.title {
  font-size: 18px;
  font-weight: bold;
  line-height: 0;
  margin-bottom: 20px;
}

.text {
  font-size: 14px;
  line-height: 14px;
}

.success {
  background: #fff;
}

.success .title {
  color: #4BB543;
}

.warning {
  background: #ffe0a4;
}

.alert {
  background: #e89898;
  color: #a20f0f;
}

/* @-webkit-keyframes notice {
  0% { opacity: 0; }
  50% {  opacity: 1; }
  100% { opacity: 0; }
} */

</style>
